"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenColumns = flattenColumns;
exports.flattenResizableColumns = flattenResizableColumns;
exports.getResizableColumn = getResizableColumn;

//
// Copyright (c) 2019 Nutanix Inc. All rights reserved.
//

/**
 * Flatten the columns prop so we can process the column definitions inside group
 * @param {Array} columns - Array of column data
 * @returns {Array} - Flattened array of column data
 */
function flattenColumns(columns) {
  var flattenedColumns = [];

  for (var i = 0; i < columns.length; i++) {
    var column = columns[i];
    flattenedColumns = flattenedColumns.concat(column);

    if (column.group && column.group.length) {
      flattenedColumns = flattenedColumns.concat(flattenColumns(column.group));
    }
  }

  return flattenedColumns;
}
/**
 * Flatten columns that are resizable.
 * @param {Array} columns - Array of column data
 * @returns {Array} - Flattened array of resizable columns
 */


function flattenResizableColumns(columns) {
  var flattenedColumns = [];

  for (var i = 0; i < columns.length; i++) {
    var column = columns[i];

    if (column.group && column.group.length) {
      flattenedColumns = flattenedColumns.concat(flattenResizableColumns(column.group));
    } else {
      flattenedColumns = flattenedColumns.concat(column);
    }
  }

  return flattenedColumns;
}
/**
 * Get resizable column from column object. If a column has a group, it is
 * not directly resizable. The furthest nested group controls the widths of its
 * containers
 * @param {Object} column - column object
 * @returns {Object} - resizable column object
 */


function getResizableColumn(column) {
  // If column object has a group, go down to the furthest nested group
  if (column.group && column.group.length) {
    return getResizableColumn(column.group[column.group.length - 1]);
  }

  return column;
}